import React from 'react';
import { X } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Button, Divider, Popover, Typography } from '@mui/material';

const exitIcon = <X style={iconSize(28)} />;

function ActivateSchedulePopup({ isOpen, onClose, onApprove }) {
  return (
    <Popover
      onClick={e => e.stopPropagation()}
      open={Boolean(isOpen)}
      transformOrigin={{ vertical: 'center', horizontal: 'center' }}
      anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      slotProps={{ backdrop: { invisible: false } }}
      onClose={onClose}>
      <Box sx={{ padding: '32px 32px 16px' }}>
        <Button onClick={onClose} sx={{ position: 'absolute', right: '12px', top: '12px' }}>
          {exitIcon}
        </Button>

        <Typography variant="h5" className="mb-4">
          Content Access Change
        </Typography>
        <Typography variant="caption" className="block max-w-[605px] text-base">
          You are activating a report that was scheduled by another user. The content of this report will be filtered according to your
          content permissions. This might change the data included in the export.
          <br />
          <br />
          Are you sure you want to proceed?
        </Typography>

        <Divider className="mb-4 mt-10" />

        <Box sx={{ ...flex.justifyEndCenter, gap: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={onApprove}>
            Continue
          </Button>
        </Box>
      </Box>
    </Popover>
  );
}

export default ActivateSchedulePopup;
